module.exports = __webpack_public_path__ + "static/media/success.f83a7f9b.png";